import { normalizePath, useSetFlowTo } from 'Simple/Flow.js'
import { useDataSubmit, useDataValue } from 'Simple/Data.js'

export function useOnClick(props) {
  let app = useDataValue({
    context: 'app',
    viewPath: props.viewPath,
  })
  let submit = useDataSubmit({
    context: 'app',
    viewPath: props.viewPath,
  })
  let setFlowTo = useSetFlowTo(props.viewPath)

  return function onClick() {
    if (app.properties) {
      let missingProperties =
        !app.company.properties ||
        app.properties.some(
          item => item.required && !(item.key in app.company.properties)
        )

      if (missingProperties) {
        setFlowTo(
          normalizePath(props.viewPath, '../../../Properties/Content/Content')
        )
        return
      }
    }

    switch (app.connection.type) {
      case 'API_TOKEN': {
        if (app.connection.token) {
          submit({ type: 'connect-api-token' })
        } else {
          setFlowTo(normalizePath(props.viewPath, 'ApiToken'))
        }
        return
      }

      case 'HTTP_JWT': {
        submit({ type: 'connect-http-jwt' })
        return
      }

      case 'OAUTH2':
      case 'OAUTH2_AUTHORIZATION_CODE': {
        setFlowTo(normalizePath(props.viewPath, 'OAuth2'))
        return
      }

      case 'OAUTH2_CLIENT_CREDENTIALS': {
        submit({ type: 'connect-oauth2-client-credentials' })
        return
      }

      default: {
        return
      }
    }
  }
}
